import React, { Component } from 'react';
import DatePicker from 'src/ui/library/DatePicker';
import InfoTooltip from 'src/ui/library/ContentParser/controls/Tooltip/InfoTooltip';
import WithHeader from '../../wrappers/WithHeader';

class DateControl extends Component {
  onChange = value => {
    this.props.onChange({ target: { value } });
  };

  renderDatePicker = () => {
    const { required, value, label, from, to, defaultYear } = this.props;
    return (
      <DatePicker
        required={required}
        label={label}
        onChange={this.onChange}
        value={value || ''}
        from={from}
        to={to}
        defaultYear={defaultYear}
      />
    );
  };

  render() {
    const { helpText } = this.props;

    let component = this.renderDatePicker();

    if (helpText) {
      component = (
        <InfoTooltip
          toolTipText={helpText}
          labelText={component}
          labelClassName="date-control-tooltip-label"
          className="date-control-tooltip"
        />
      );
    }

    return component;
  }
}

export default WithHeader(DateControl);
